/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PatchedUpdateTemplate
 */
export interface PatchedUpdateTemplate {
  /**
   *
   */
  name?: string;
}

/**
 * Check if a given object implements the PatchedUpdateTemplate interface.
 */
export function instanceOfPatchedUpdateTemplate(value: object): value is PatchedUpdateTemplate {
  return true;
}

export function PatchedUpdateTemplateFromJSON(json: any): PatchedUpdateTemplate {
  return PatchedUpdateTemplateFromJSONTyped(json, false);
}

export function PatchedUpdateTemplateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedUpdateTemplate {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"] == null ? undefined : json["name"],
  };
}

export function PatchedUpdateTemplateToJSON(json: any): PatchedUpdateTemplate {
  return PatchedUpdateTemplateToJSONTyped(json, false);
}

export function PatchedUpdateTemplateToJSONTyped(
  value?: PatchedUpdateTemplate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
  };
}
